import { Tabs, Tab, Box, useTheme } from '@mui/material';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import HistoryIcon from '@mui/icons-material/History';
import PaymentIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';
import { useLoanContext } from '../LoanContext';

const tabList = [
  { label: 'Loan Summary', value: 'summary', icon: InsertDriveFileIcon },
  { label: 'Repayment History', value: 'repayment-history', icon: PaymentIcon },
  { label: 'Amortisation Schedule', value: 'schedule', icon: CalendarTodayIcon },
  { label: 'Make Payment', value: 'payments', icon: CurrencyPoundIcon },
  // { label: 'Transaction Summary', value: 'transaction-summary', icon: HistoryIcon },
  { label: 'Loan Statement', value: 'loan-statement', icon: DescriptionIcon },
  { label: 'Bills', value: 'bills', icon: ReceiptLongIcon },
  { label: 'Payoff Calculator', value: 'payoff', icon: AccountBalanceWalletIcon },
  { label: 'Rate Schedule', value: 'rate-schedule', icon: TrendingUpIcon },
  // { label: 'Parties', value: 'parties', icon: GroupsIcon },
];

const LoanDetailsTabs: React.FC = () => {
  const { loanId } = useParams();
  const location = useLocation();
  const theme = useTheme();
  const { loan } = useLoanContext();
  const isFloatingRateLoan = String(loan?.rateType ?? '').toLowerCase() === 'floating';
  const visibleTabs = tabList.filter((tab) =>
    tab.value === 'rate-schedule' ? isFloatingRateLoan : true
  );
  // Determine the active tab from the URL
  const activeTab = (() => {
    // Special case: payment-method route should highlight Payments tab
    if (location.pathname.includes('/payment-method')) {
      return 'payments';
    }
    // Regular tab matching
    return visibleTabs.find(tab => location.pathname.includes(`/${tab.value}`))?.value || 'summary';
  })();
  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={activeTab}
        variant="standard"
        textColor="inherit"
        TabIndicatorProps={{
          style: {
            background: theme.palette.primary.main,
            height: 3,
            borderRadius: 2,
          },
        }}
        sx={{
          mb: 2,
          width: 'fit-content',
          mx: 'auto',
          borderBottom: `1.5px solid ${theme.palette.divider}`,
          background: 'transparent',
          color: theme.palette.text.secondary,
          '.Mui-selected': {
            color: theme.palette.primary.main,
          },
          '& .MuiTabs-flexContainer': {
            justifyContent: 'center',
            columnGap: 0.5,
          },
        }}
      >
        {visibleTabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.value;
          return (
            <Tab
              key={tab.value}
              icon={<Icon sx={{ fontSize: 18, color: isActive ? theme.palette.primary.main : 'inherit' }} />}
              iconPosition="start"
              label={tab.label}
              value={tab.value}
              component={NavLink}
              to={`/loans/${loanId}/${tab.value}`}
              sx={{
                fontFamily: "'Libre Franklin', sans-serif",
                fontWeight: 500,
                fontSize: 11,
                minHeight: 38,
                minWidth: 'auto',
                color: isActive ? theme.palette.primary.main : '#fff',
                '&.Mui-selected': {
                  color: theme.palette.primary.main,
                },
                textTransform: 'uppercase',
                px: 0.75,
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

export default LoanDetailsTabs; 
